// List of Russian cities with population > 50,000
export const RUSSIAN_CITIES = [
  "Москва", "Санкт-Петербург", "Новосибирск", "Екатеринбург", "Казань",
  "Нижний Новгород", "Челябинск", "Самара", "Омск", "Ростов-на-Дону",
  "Уфа", "Красноярск", "Воронеж", "Пермь", "Волгоград",
  "Краснодар", "Саратов", "Тюмень", "Тольятти", "Ижевск",
  "Барнаул", "Ульяновск", "Иркутск", "Хабаровск", "Ярославль",
  "Владивосток", "Махачкала", "Томск", "Оренбург", "Кемерово",
  "Новокузнецк", "Рязань", "Астрахань", "Набережные Челны", "Пенза",
  "Липецк", "Киров", "Чебоксары", "Тула", "Калининград",
  "Балашиха", "Курск", "Ставрополь", "Улан-Удэ", "Сочи",
  "Тверь", "Магнитогорск", "Иваново", "Брянск", "Белгород",
  "Сургут", "Владимир", "Нижний Тагил", "Архангельск", "Чита",
  "Калуга", "Смоленск", "Волжский", "Курган", "Орёл",
  "Череповец", "Владикавказ", "Мурманск", "Вологда", "Саранск",
  "Тамбов", "Грозный", "Стерлитамак", "Кострома", "Петрозаводск",
  "Нижневартовск", "Йошкар-Ола", "Новороссийск", "Таганрог", "Комсомольск-на-Амуре",
  "Сыктывкар", "Братск", "Нальчик", "Дзержинск", "Шахты",
  "Нижнекамск", "Орск", "Ангарск", "Благовещенск", "Великий Новгород",
  "Старый Оскол", "Энгельс", "Королёв", "Псков", "Бийск",
  "Прокопьевск", "Рыбинск", "Балаково", "Мытищи", "Норильск",
  "Люберцы", "Южно-Сахалинск", "Армавир", "Петропавловск-Камчатский", "Северодвинск",
  "Подольск", "Златоуст", "Химки", "Каменск-Уральский", "Сызрань",
  "Копейск", "Волгодонск", "Новочеркасск", "Находка", "Абакан",
  "Березники", "Майкоп", "Пятигорск", "Миасс", "Коломна",
  "Рубцовск", "Ковров", "Альметьевск", "Одинцово", "Хасавюрт",
  "Уссурийск", "Красногорск", "Кисловодск", "Новомосковск", "Серпухов",
  "Первоуральск", "Нефтекамск", "Нефтеюганск", "Димитровград", "Черкесск",
  "Новочебоксарск", "Орехово-Зуево", "Дербент", "Невинномысск", "Камышин",
  "Батайск", "Муром", "Новый Уренгой", "Октябрьский", "Кызыл",
  "Северск", "Ноябрьск", "Сергиев Посад", "Елец", "Новошахтинск",
  "Ессентуки", "Обнинск", "Каспийск", "Арзамас", "Элиста",
  "Щёлково", "Ачинск", "Назрань", "Жуковский", "Бердск",
  "Ногинск", "Пушкино", "Ленинск-Кузнецкий", "Долгопрудный", "Воскресенск",
  "Реутов", "Домодедово", "Глазов", "Железногорск", "Раменское",
  "Магадан", "Ханты-Мансийск", "Анапа", "Салават", "Воткинск",
  "Междуреченск", "Туапсе", "Соликамск", "Серов", "Ишим",
  "Всеволожск", "Геленджик", "Гатчина", "Выборг", "Кинешма",
  "Зеленодольск", "Ейск", "Бузулук", "Клин", "Великие Луки"
].sort();
